import { render } from "./QuizRestart.vue?vue&type=template&id=376e7ae0&scoped=true&ts=true"
import script from "./QuizRestart.vue?vue&type=script&lang=ts"
export * from "./QuizRestart.vue?vue&type=script&lang=ts"

import _style_0 from "./QuizRestart.vue?vue&type=style&index=0&id=376e7ae0&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-376e7ae0"]])

export default __exports__